module.exports = "../static/media/banner.ac82bef9.png";